import React, { createRef, forwardRef, type ComponentProps } from "react";

import { createUseStyles } from "react-jss";
import { QueryBuilderComponent as SyncfusionQueryBuilderComponent } from "@syncfusion/ej2-react-querybuilder";
// Every prop is forwarded verbatim to Syncfusion's QueryBuilder.
type QueryBuilderProps = ComponentProps<typeof SyncfusionQueryBuilderComponent>;

const QueryBuilderComponent = forwardRef((props: QueryBuilderProps, ref: React.Ref<unknown>) => {
  const queryBuilderRef = ref || createRef<unknown>();
  const useStyles = createUseStyles({
    QueryBuilderComponent: {
      "& .e-rule-filter, & .e-rule-operator.e-operator, & .e-rule-value.e-value": {
        width: "26% !important",
        minWidth: "9.375rem",
      },
      "& .e-query-builder": {
        border: "none",
      },
      "& .e-query-builder .e-rule-container": {
        backgroundColor: "#fff",
      },
    },
  });

  const classes = useStyles() as Record<"QueryBuilderComponent", string>;

  return (
    <div className={classes.QueryBuilderComponent} id="QueryBuilderComponentWrapper">
      <SyncfusionQueryBuilderComponent
        {...props}
        className={classes.QueryBuilderComponent}
        ref={queryBuilderRef as React.Ref<SyncfusionQueryBuilderComponent>}
      >
        {props.children}
      </SyncfusionQueryBuilderComponent>
    </div>
  );
});
QueryBuilderComponent.displayName = "QueryBuilderComponent";
export default QueryBuilderComponent;
